var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{attrs:{"src":_vm.icon['1x'],"srcset":((_vm.icon['1x']) + " 1x, " + (_vm.icon['2x']) + " 2x, " + (_vm.icon['3x']) + " 3x"),"alt":""},on:{"click":function($event){return _vm.$emit('click', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }